const EPG_COLUMN_GAP_STEP = 8;

/** Compact phone/web row height, shared so the FlatList `getItemLayout` math stays exact. */
export const EPG_COMPACT_ROW_HEIGHT = 70;

/** Phone/web EPG chrome fill: Figma's subtle tint over the page, not the CMS surface (estimate). */
export const EPG_SURFACE_OPACITY = 0.06;

export default EPG_COLUMN_GAP_STEP;
